import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';

/**
 * Field and form-wide fill prompts in the PDF form editor. The backend reads the
 * same key for the fill model. Rollout gate, not an experiment: no manual exposure.
 */
export const useIsFormFillPromptsEnabled = () => {
  return useFeatureFlagEnabled('release-growth-form-fill-prompts') ?? false;
};
